// extracted by mini-css-extract-plugin
export default {"item":"NavigationItem_item__o+qbf","item_selected":"NavigationItem_item_selected__n4tnq","item_alert":"NavigationItem_item_alert__ItFEu"};